/**
 * 最小缩放等级
 */
export const CANVAS_MIN_ZOOM_LEVEL = 0.2;

/**
 * 最大缩放等级
 */
export const CANVAS_MAX_ZOOM_LEVEL = 4;
